jQuery(function($){

  $(document).ready(function() {
    $('.js-accordion_grandchild').click(function() {
      var $grandchild = $(this).next('.js-grandchild');
      var $accordion = $(this);
      
      $grandchild.slideToggle(400, function() {
        if ($grandchild.is(':visible')) {
          $grandchild.css('display', 'block');
          $accordion.addClass('active');
        } else {
          $accordion.removeClass('active');
        }
      });
    });
  });
  
  $('.js-acordion_head').click(function() {
     var windowWidth = window.innerWidth;
     if (windowWidth <= 768) {
        $(this).toggleClass('active');
        $(this).next('.js-acordion_area').slideToggle();
     }
  });
    $('.js-accordion-txt').click(function() {
     var windowWidth = window.innerWidth;
     if (windowWidth <= 768) {
        $(this).toggleClass('active');
        $(this).next('.js-collection-list').slideToggle();
     }
  });
});

function changeDisabled(){
  optin = document.getElementById('optin');
  if(optin.checked) {
    document.getElementById('checkout_btn').disabled = "";
  } else {
    document.getElementById('checkout_btn').disabled = "disabled";
  }
}
$(function(){
  
  $('#checkout_btn').on('click', function(e) {
    password = $('.input-password').val();
    if (password.match(/^(?=.*?[a-z])(?=.*?\d)[a-z\d]{8,100}$/i)) {
      //alert('match');
    } else {
      alert('英数字混在8桁以上で設定してください');
      return false;
    }
  });
  
  $('.toggle_switch').on('click',function(){
    $(this).toggleClass('open');
    $(this).next('.toggle_contents').slideToggle();
  });
  $('.bar__closeButton').on('click', function(){
     $('body').removeClass('free-shipping');
  });
  
  /* scroll swing */
  $('a[href^="#"]:not(.modal)').click(function(){
    let speed = 500;
    let href= $(this).attr("href");
    let target = $(href == "#" || href == "" ? 'html' : href);
    let position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });

  $(".modal").modaal();

  window.addEventListener('load', function() {

    var mesmaxHeight = 0;
    var stfmaxHeight = 0;
    
    $('.top-slide').slick({
      autoplay:true,
      speed: 400,
      arrows:true,
      autoplaySpeed:2000,
      slidesToShow:1,
      infinite:true,
      prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0867/6212/7658/files/arrow_w_prev.png" class="slide-arrow w-prev-arrow">',
      nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0867/6212/7658/files/arrow_w_next.png" class="slide-arrow w-next-arrow">',
      responsive: [{
        breakpoint: 1025,
        settings: {
          speed: 1200
        }
      }]
    });
  
    $('.message-slide').slick({
      autoplay:false,
      speed: 400,
      arrows:true,
      autoplaySpeed:2000,
      slidesToShow:3,
      prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0867/6212/7658/files/arrow_prev.png" class="slide-arrow prev-arrow">',
      nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0867/6212/7658/files/arrow_next.png" class="slide-arrow next-arrow">',
      responsive: [{
        breakpoint: 1025,
        settings: {
          slidesToShow:1
        }
      }]
    });
  
    $('.staff-slide').slick({
      autoplay:false,
      speed: 400,
      arrows:true,
      autoplaySpeed:2000,
      slidesToShow:3,
      prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0867/6212/7658/files/arrow_prev.png" class="slide-arrow prev-arrow">',
      nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0867/6212/7658/files/arrow_next.png" class="slide-arrow next-arrow">',
      responsive: [{
        breakpoint: 1025,
        settings: {
          slidesToShow:1
        }
      }]
    });
    $('#switch2').click(function () {
      $('.staff-slide').slick('setPosition');
      $('.staff-slide li').height('100%');
      $('.staff-slide li').each(function(idx, elem) {
        var height = $(elem).height();
        if(stfmaxHeight < height) {
          stfmaxHeight = height;
        }
      });
      $('.staff-slide li').height(stfmaxHeight);
    });

    /*
    $('.insta-slide').slick({
      autoplay:false,
      speed: 400,
      arrows:true,
      autoplaySpeed:2000,
      slidesToShow:4,
      prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0867/6212/7658/files/arrow_prev.png" class="slide-arrow prev-arrow">',
      nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0867/6212/7658/files/arrow_next.png" class="slide-arrow next-arrow">',
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow:1
        }
      }]
    });
    */

    $('.message-slide li').each(function(idx, elem) {
      var height = $(elem).height();
      if(mesmaxHeight < height) {
        mesmaxHeight = height;
      }
    });
    $('.message-slide li').height(mesmaxHeight);

    $('.staff-slide li').each(function(idx, elem) {
      var height = $(elem).height();
      if(stfmaxHeight < height) {
        stfmaxHeight = height;
      }
    });
    $('.staff-slide li').height(stfmaxHeight);
    /*$('#switch2').prop("checked", false);*/
    
  });
  $(window).on('resize orientationchange', function() {
    var mesmaxHeight = 0;
    var stfmaxHeight = 0;
    
    $('.message-slide li').each(function(idx, elem) {
      var height = $(elem).height();
      if(mesmaxHeight < height) {
        mesmaxHeight = height;
      }
    });
    $('.message-slide li').height(mesmaxHeight);

    $('.staff-slide li').each(function(idx, elem) {
      var height = $(elem).height();
      if(stfmaxHeight < height) {
        stfmaxHeight = height;
      }
    });
    $('.staff-slide li').height(stfmaxHeight);
  });
  (function(){
  	
  	"use strict";
  	
  	var init;
  	
  	init = function(){
  		
  		$('.s-slide').slick({
  			autoplay:true,
  			autoplaySpeed:2000,
  			speed: 400,
  			arrows:false,
  			fade:true,
  			infinite:true
  		});
  		
  	};
  	
  	$(function(){
  		init();
  	});
  	/*
  	var smoothScroll;
  	smoothScroll = function(){
  		
  		var
  			$target = $('a.is-smoothScroll'),
  			smooth
  			;
  		
  		smooth = function(e){
  			
  			var position = this.href.split('#')[1];
  			
  			e.preventDefault();
  			
  			position = (position==='' || !document.getElementById(position)) ? 0 : $(document.getElementById(position)).offset().top;
  			
  			$('html, body').animate(
  				{'scrollTop':position-20},
  				400,
  				'swing');
  			
  		};
  		
  		if($target.length===0){
  			
  			$('a[href^=#]').click(smooth);
  			
  		}else{
  			
  			$target.click(smooth);
  			
  		}
  		
  	};
  $(document).ready(function() {
      var feed = new Instafeed({
          get: 'tagged', //ハッシュタグから取得
          tagName: 'ピープルツリー', //好きなハッシュタグを設定
          sortBy:'random', //並び順をランダムに
          links: true , //画像リンク取得
          limit: 12, //取得する画像数を設定
          resolution: 'low_resolution', //画像サイズを設定
          template: '<li><a href="{{link}}"><img src="{{image}}" target="_blank" /></a><span>{{caption}}</span><span>like:{{likes}},comments:{{comments}}</span></li>',
          clientId: 'e961f684a8d4481daa13383edc721c0d', //Instagram DevelopersのクライアントID
  		accessToken: '2211935133.e961f68.cc6404fcfaa243edbfd6602b47d92f49'
      });
      feed.run();
  });*/
  	
  	 
  }());

    $('.slider').each(function(){
		$(this).slick({
			autoplay:true,
			autoplaySpeed:3000,
			dots:true,
		});
	});
        $('.autoplay').slick({
		  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
      });

	$("img.ChangePhoto").click(function(){
		var ImgSrc = $(this).attr("src");
		var ImgAlt = $(this).attr("alt");
		$("img#MainPhoto").attr({src:ImgSrc,alt:ImgAlt});
		$("img#MainPhoto").hide();
		$("img#MainPhoto").fadeIn("fast");
		return false;
	});
	$("img.ChangePhoto_b").click(function(){
		var ImgSrc = $(this).attr("src");
		var ImgAlt = $(this).attr("alt");
		$("img#MainPhoto_b").attr({src:ImgSrc,alt:ImgAlt});
		$("img#MainPhoto_b").hide();
		$("img#MainPhoto_b").fadeIn("fast");
		return false;
	});
	$("img.ChangePhoto_c").click(function(){
		var ImgSrc = $(this).attr("src");
		var ImgAlt = $(this).attr("alt");
		$("img#MainPhoto_c").attr({src:ImgSrc,alt:ImgAlt});
		$("img#MainPhoto_c").hide();
		$("img#MainPhoto_c").fadeIn("fast");
		return false;
	});
	$("img.ChangePhoto_d").click(function(){
		var ImgSrc = $(this).attr("src");
		var ImgAlt = $(this).attr("alt");
		$("img#MainPhoto_d").attr({src:ImgSrc,alt:ImgAlt});
		$("img#MainPhoto_d").hide();
		$("img#MainPhoto_d").fadeIn("fast");
		return false;
	});
	$("img.ChangePhoto_e").click(function(){
		var ImgSrc = $(this).attr("src");
		var ImgAlt = $(this).attr("alt");
		$("img#MainPhoto_e").attr({src:ImgSrc,alt:ImgAlt});
		$("img#MainPhoto_e").hide();
		$("img#MainPhoto_e").fadeIn("fast");
		return false;
	});
	$(".image_wrap ul li img").click(function(){
		$("div.image_wrap p img", $(this).parents(".image_wrap")).attr("src", $(this).attr("src"));
		// 自分の親の.image_wrap内のimgに対してselected属性を削除する
		$(this).parents('.image_wrap').find('img').removeClass('selected');
		// クリックされた画像にselected属性を追加
		$(this).addClass('selected');
	}).css('cursor','pointer');
  
});

